module.exports = __webpack_public_path__ + "img/ne.5293b50a.png";